import { fetchUserAccountBalance } from '../api';
import { Env } from '@/shared/config/environment';
import { LocalStore } from '@/shared/lib/local-storage';

const state = {
  balanceHidden: new LocalStore('balance_').get('hidden', false),
  balanceAmount: undefined,
  creditLimit: undefined,
  isLoadingBalance: false,
  balanceError: null,
};

const mutations = {
  SET_LOADING_BALANCE(state, isLoadingBalance) {
    state.isLoadingBalance = isLoadingBalance;
  },
  SET_BALANCE(state, balance) {
    state.balanceAmount = balance;
  },
  SET_CREDIT_LIMIT(state, creditLimit) {
    state.creditLimit = creditLimit;
  },
  SET_BALANCE_ERROR(state, error) {
    state.balanceError = error;
  },
  SET_BALANCE_HIDDEN(state, balanceHidden) {
    state.balanceHidden = balanceHidden;
    new LocalStore('balance_').set('hidden', balanceHidden);
  },
};

const actions = {
  async fetchUserAccountBalance({ commit, dispatch }) {
    commit('SET_LOADING_BALANCE', true);
    commit('SET_BALANCE_ERROR', null);

    try {
      const balance = await fetchUserAccountBalance();
      commit('SET_BALANCE', balance?.amount);
      commit('SET_CREDIT_LIMIT', balance?.creditLimit);

      return balance;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Помилка при отриманні данних про поточний баланс користувача';

      commit('SET_BALANCE_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося отримати дані про поточний баланс користувача',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_BALANCE', false);
    }
  },
  hideBalance({ commit },  balanceHidden) {
    commit('SET_BALANCE_HIDDEN', balanceHidden);
  },
};

const getters = {
  isBalanceLoading: (state) => state.isLoadingBalance,
  isBalanceDataReady: (state) => /*!state.isLoadingBalance &&*/ state.balanceAmount !== undefined /*&& state.creditLimit !== undefined*/,
  balanceError: (state) => state.balanceError,
  isBalanceHidden: (state) => state.balanceHidden,
  getBalanceAmount: (state) => Number(state.balanceAmount || 0),
  getCreditLimit: (state) => Number(state.creditLimit || 0),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
